import React, { useState } from 'react';
import styled from 'styled-components';
import Footer from '../components/Footer';

const Container = styled.div`
  background: #ffffff;
  min-height: 100vh;
  color: #000000;
`;

const HeroSection = styled.div`
  background: #ffffff;
  color: #000000;
  padding: 80px 20px 60px;
  text-align: center;
  border-bottom: 1px solid #eee;
`;

const HeroContent = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

const PageTitle = styled.h1`
  font-size: 3rem;
  font-weight: 900;
  margin: 0 0 20px 0;
  color: #000000;
  
  @media (max-width: 768px) {
    font-size: 2.2rem;
  }
`;

const PageSubtitle = styled.p`
  font-size: 1.3rem;
  color: #666666;
  line-height: 1.6;
  margin: 0;
`;

const ContentSection = styled.div`
  padding: 80px 20px;
  max-width: 1000px;
  margin: 0 auto;
`;

const StorySection = styled.div`
  margin-bottom: 80px;
`;

const SectionTitle = styled.h2`
  font-size: 2.5rem;
  font-weight: 800;
  margin-bottom: 30px;
  color: #000000;
  text-align: center;
`;

const StoryContent = styled.div`
  font-size: 1.2rem;
  line-height: 1.8;
  color: #333333;
  
  p {
    margin-bottom: 25px;
  }
  
  strong {
    color: #000000;
  }
`;

const FounderSection = styled.div`
  background: #f8f8f8;
  padding: 60px 40px;
  border-radius: 12px;
  margin-bottom: 80px;
  text-align: center;
`;

const FounderTitle = styled.h3`
  font-size: 2rem;
  font-weight: 800;
  margin-bottom: 20px;
  color: #000000;
`;

const FounderBio = styled.div`
  font-size: 1.1rem;
  line-height: 1.7;
  color: #444444;
  max-width: 800px;
  margin: 0 auto;
  
  p {
    margin-bottom: 20px;
  }
`;

const ValuesSection = styled.div`
  margin-bottom: 80px;
`;

const ValuesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 40px;
  margin-top: 40px;
`;

const ValueCard = styled.div`
  background: #ffffff;
  color: #000000;
  padding: 40px 30px;
  border-radius: 12px;
  text-align: center;
  border: 1px solid #e0e0e0;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
  transition: transform 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
  }
`;

const ValueIcon = styled.div`
  font-size: 3rem;
  margin-bottom: 20px;
`;

const ValueTitle = styled.h4`
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 15px;
  color: #000000;
`;

const ValueDescription = styled.p`
  font-size: 1rem;
  line-height: 1.6;
  color: #555555;
  margin: 0;
`;

const CompanySection = styled.div`
  background: #f8f8f8;
  padding: 60px 40px;
  border-radius: 12px;
  text-align: center;
`;

const CompanyTitle = styled.h3`
  font-size: 2rem;
  font-weight: 800;
  margin-bottom: 20px;
  color: #000000;
`;

const CompanyInfo = styled.div`
  font-size: 1.1rem;
  line-height: 1.7;
  color: #444444;
  
  p {
    margin-bottom: 15px;
  }
  
  strong {
    color: #000000;
  }
`;

const CTASection = styled.div`
  background: #f8f9fa;
  color: #000000;
  padding: 80px 20px;
  text-align: center;
  border: 1px solid #e0e0e0;
`;

const CTAContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

const CTATitle = styled.h2`
  font-size: 2.5rem;
  font-weight: 800;
  margin-bottom: 20px;
  color: #000000;
`;

const CTADescription = styled.p`
  font-size: 1.2rem;
  margin-bottom: 40px;
  color: #555555;
  line-height: 1.6;
`;

const CTAButton = styled.button`
  background: #007AFF;
  color: #ffffff;
  border: none;
  padding: 18px 40px;
  font-size: 1.2rem;
  font-weight: 700;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background: #0056b3;
    transform: translateY(-2px);
  }
`;

// New styled components for additional sections
const TeamSection = styled.div`
  margin-bottom: 80px;
`;

const TeamGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 40px;
  margin-top: 40px;
`;

const TeamMember = styled.div`
  text-align: center;
  padding: 30px;
  background: #f8f9fa;
  border-radius: 12px;
  transition: transform 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
  }
`;

const TeamPhoto = styled.div`
  font-size: 4rem;
  margin-bottom: 20px;
`;

const TeamName = styled.h4`
  font-size: 1.3rem;
  margin-bottom: 8px;
  color: #333;
`;

const TeamRole = styled.div`
  color: #666;
  font-weight: 600;
  margin-bottom: 15px;
`;

const TeamBio = styled.p`
  color: #666;
  line-height: 1.6;
  font-size: 0.95rem;
`;

const ContactSection = styled.div`
  margin-bottom: 80px;
`;

const ContactGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
  margin-top: 40px;
`;

const ContactCard = styled.div`
  background: white;
  border: 1px solid #eee;
  border-radius: 12px;
  padding: 30px;
  text-align: center;
  transition: transform 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  }
`;

const ContactIcon = styled.div`
  font-size: 2.5rem;
  margin-bottom: 15px;
`;

const ContactType = styled.h4`
  font-size: 1.2rem;
  margin-bottom: 10px;
  color: #333;
`;

const ContactDetail = styled.div`
  font-size: 1.1rem;
  font-weight: 600;
  color: #007AFF;
  margin-bottom: 10px;
`;

const ContactDescription = styled.p`
  color: #666;
  font-size: 0.9rem;
  line-height: 1.5;
`;

const FAQSection = styled.div`
  margin-bottom: 80px;
`;

const FAQList = styled.div`
  max-width: 800px;
  margin: 40px auto 0 auto;
`;

const FAQItem = styled.div`
  border-bottom: 1px solid #eee;
  
  &:last-child {
    border-bottom: none;
  }
`;

const FAQQuestion = styled.button`
  width: 100%;
  padding: 20px 0;
  text-align: left;
  background: none;
  border: none;
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  &:hover {
    color: #007AFF;
  }
`;

const FAQAnswer = styled.div`
  padding: 0 0 20px 0;
  color: #666;
  line-height: 1.6;
  animation: fadeIn 0.3s ease;
  
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

const PressSection = styled.div`
  margin-bottom: 80px;
`;

const PressContent = styled.div`
  margin-top: 40px;
`;

const PressItem = styled.div`
  margin-bottom: 40px;
  padding-bottom: 40px;
  border-bottom: 1px solid #eee;
  
  &:last-of-type {
    border-bottom: none;
  }
`;

const PressDate = styled.div`
  color: #007AFF;
  font-weight: 600;
  margin-bottom: 10px;
`;

const PressTitle = styled.h4`
  font-size: 1.3rem;
  margin-bottom: 15px;
  color: #333;
`;

const PressDescription = styled.p`
  color: #666;
  line-height: 1.6;
`;

const MediaContact = styled.div`
  background: #f8f9fa;
  padding: 30px;
  border-radius: 12px;
  margin-top: 40px;
`;

const MediaTitle = styled.h4`
  font-size: 1.2rem;
  margin-bottom: 15px;
  color: #333;
`;

const MediaInfo = styled.div`
  color: #666;
  line-height: 1.6;
`;

const About = ({ user }) => {
  const [openFAQ, setOpenFAQ] = useState(null);
  
  const handleGetStarted = () => {
    if (user) {
      window.location.href = '/showingbooker/dashboard';
    } else {
      window.location.href = '/register';
    }
  };

  return (
    <Container>
      <HeroSection>
        <HeroContent>
          <PageTitle>About ShowingBooker</PageTitle>
          <PageSubtitle>
            Revolutionary real estate showing management born from 30+ years of hands-on experience 
            in Los Angeles property management, compliance challenges, and real estate transactions.
          </PageSubtitle>
        </HeroContent>
      </HeroSection>

      <ContentSection>
        <StorySection>
          <SectionTitle>ShowingBooker: The Service</SectionTitle>
          <StoryContent>
            <p>
              <strong>ShowingBooker revolutionizes real estate showing coordination</strong> by automating the complex 
              process of scheduling private property viewings while ensuring complete legal compliance. Born from 
              decades of frustration with inefficient showing processes, our platform eliminates the endless phone 
              tag, missed appointments, and compliance headaches that plague real estate professionals.
            </p>
            
            <p>
              <strong>For Real Estate Professionals:</strong> ShowingBooker is 100% FREE, providing automated booking 
              systems, compliance tracking, certified mail notifications, and complete audit trails. Real estate agents, leasing agents, and 
              property owners can list unlimited properties without any monthly fees or hidden costs.
            </p>
            
            <p>
              <strong>For Buyers, Renters, and Agents:</strong> A simple $25 per booking fee provides instant access 
              to property tours (for homes and rentals), automated notifications, and professional coordination that proves your 
              seriousness as a qualified prospect.
            </p>
            
            <p>
              <strong>Legal Compliance at its Core:</strong> Every booking automatically generates California Civil Code 
              Section 1954 compliant notifications, proper advance notice to tenants, certified mail documentation, 
              and complete legal audit trails - protecting all parties from liability while streamlining the process.
            </p>
            
            <p>
              ShowingBooker transforms what was once a time-consuming, error-prone manual process into a 
              professional, automated system that works 24/7 to maximize showing opportunities while 
              minimizing administrative burden.
            </p>
          </StoryContent>
        </StorySection>

        <StorySection>
          <SectionTitle>For Leasing Agents and Property Managers</SectionTitle>
          <StoryContent>
            <p>
              <strong>Perfect for Rental Properties:</strong> ShowingBooker streamlines the rental showing process 
              for leasing agents, property managers, and landlords. Whether you're showing apartments, condos, 
              single-family homes, or commercial spaces, our platform ensures proper tenant notification and 
              professional coordination for all rental showings.
            </p>
            
            <p>
              <strong>Rental-Specific Features:</strong> Automated Civil Code Section 1954 compliance for tenant 
              occupied units, proper advance notice delivery, and complete documentation trails that protect 
              both landlords and tenants. Perfect for property management companies handling multiple rental properties.
            </p>
            
            <p>
              <strong>Streamline Your Rental Business:</strong> Reduce no-shows with our $25 confirmation fee system, 
              automate tenant notifications, and maintain professional standards that attract quality renters while 
              protecting your time and ensuring legal compliance.
            </p>
          </StoryContent>
        </StorySection>

        <FounderSection>
          <FounderTitle>Industry Expertise Behind ShowingBooker</FounderTitle>
          <FounderBio>
            <p>
              <strong>Professional Real Estate Experience</strong> forms the foundation of ShowingBooker. 
              Built by licensed California real estate professionals with decades of experience in complex transactions, 
              buyer relations, city compliance, and auditing processes.
            </p>
            
            <p>
              <strong>Property Management Insight:</strong> ShowingBooker's development is rooted in extensive 
              property management experience, providing deep understanding of operational challenges and 
              practical solutions for the industry.
            </p>
            
            <p>
              <strong>Real Estate Investment Background:</strong> Our platform is designed by professionals with 
              hands-on experience in property ownership and management in Los Angeles, one of the nation's most 
              challenging real estate markets.
            </p>
            
            <p>
              <strong>Los Angeles Market Expertise:</strong> Developed with deep understanding of the complexities 
              of Los Angeles real estate, including the intricate web of city compliance, tenant rights, and 
              regulatory requirements that make LA real estate uniquely challenging.
            </p>
            
            <p>
              ShowingBooker isn't theoretical - it's a practical solution born from decades of real-world 
              experience in Los Angeles real estate, addressing the daily challenges of showing coordination, 
              compliance tracking, and tenant notifications.
            </p>
          </FounderBio>
        </FounderSection>

        <ValuesSection>
          <SectionTitle>What Makes ShowingBooker Unique</SectionTitle>
          <ValuesGrid>
            <ValueCard>
              <ValueIcon>🏢</ValueIcon>
              <ValueTitle>30+ Years Real Experience</ValueTitle>
              <ValueDescription>
                Built by professionals who have managed properties, coordinated showings, 
                and navigated LA compliance for decades. Not theory - real experience.
              </ValueDescription>
            </ValueCard>
            
            <ValueCard>
              <ValueIcon>⚖️</ValueIcon>
              <ValueTitle>LA Compliance Mastery</ValueTitle>
              <ValueDescription>
                Designed by property management professionals with extensive experience in LA tenant law, 
                city audits, and regulatory compliance in America's most challenging rental market.
              </ValueDescription>
            </ValueCard>
            
            <ValueCard>
              <ValueIcon>🎯</ValueIcon>
              <ValueTitle>Industry-Specific Innovation</ValueTitle>
              <ValueDescription>
                CodexDeus specializes in niche real estate solutions, not generic software. 
                Every feature addresses real industry pain points.
              </ValueDescription>
            </ValueCard>
            
            <ValueCard>
              <ValueIcon>💰</ValueIcon>
              <ValueTitle>Agent-First Business Model</ValueTitle>
              <ValueDescription>
                100% FREE for agents and property owners forever. Only buyers pay, 
                aligning our success with yours.
              </ValueDescription>
            </ValueCard>
            
            <ValueCard>
              <ValueIcon>🔒</ValueIcon>
              <ValueTitle>Built for Scale</ValueTitle>
              <ValueDescription>
                Professional-grade platform designed to handle everything from single 
                properties to large portfolio management.
              </ValueDescription>
            </ValueCard>
            
            <ValueCard>
              <ValueIcon>📋</ValueIcon>
              <ValueTitle>Automation + Compliance</ValueTitle>
              <ValueDescription>
                Eliminates manual processes while ensuring every showing meets 
                California legal requirements automatically.
              </ValueDescription>
            </ValueCard>
          </ValuesGrid>
        </ValuesSection>

        <CompanySection>
          <CompanyTitle>Professional Real Estate Technology Solutions</CompanyTitle>
          <CompanyInfo>
            <p>
              <strong>ShowingBooker is developed by industry professionals</strong> with extensive experience in 
              real estate technology. Our Los Angeles-based development team specializes in creating innovative 
              niche products for the real estate industry. Our approach combines deep industry expertise with 
              cutting-edge technology to solve real-world problems.
            </p>
            
            <p>
              <strong>Company Focus:</strong> Unlike generic software companies, CodexDeus specializes in developing 
              highly targeted solutions for specific industry pain points. Our real estate focus allows us to 
              create products that truly understand the nuances and complexities of property management, 
              compliance, and transaction coordination.
            </p>
            
            <p>
              <strong>Industry-Specific Innovation:</strong> Each CodexDeus product is born from genuine industry 
              experience and addresses real problems that generic software solutions often miss. We believe that 
              the best technology comes from those who have actually lived the challenges they're solving.
            </p>
            
            <p>
              <strong>Company Details:</strong><br/>
              <strong>Location:</strong> Los Angeles, California<br/>
              <strong>Specialization:</strong> Real Estate Technology Solutions<br/>
              <strong>Contact:</strong> hello@showingbooker.com<br/>
              <strong>Mission:</strong> Creating niche products that solve specific industry challenges with precision and expertise
            </p>
          </CompanyInfo>
        </CompanySection>

        {/* Team Section */}
        <TeamSection>
          <SectionTitle>Our Team</SectionTitle>
          <TeamGrid>
            <TeamMember>
              <TeamPhoto>👨‍💼</TeamPhoto>
              <TeamName>David Bramante</TeamName>
              <TeamRole>Founder & CEO</TeamRole>
              <TeamBio>
                Former real estate agent with deep expertise in California compliance and tenant-occupied property management. 
                Built ShowingBooker to solve the exact challenges he faced managing complex showing schedules.
              </TeamBio>
            </TeamMember>
            <TeamMember>
              <TeamPhoto>👩‍💻</TeamPhoto>
              <TeamName>Engineering Team</TeamName>
              <TeamRole>Product Development</TeamRole>
              <TeamBio>
                Experienced developers specializing in real estate technology, compliance automation, and secure booking systems. 
                Committed to building tools that truly serve real estate professionals.
              </TeamBio>
            </TeamMember>
            <TeamMember>
              <TeamPhoto>👨‍🏫</TeamPhoto>
              <TeamName>Industry Advisors</TeamName>
              <TeamRole>Real Estate Experts</TeamRole>
              <TeamBio>
                Active agents and brokers from top California firms who provide ongoing feedback to ensure ShowingBooker 
                meets the evolving needs of real estate professionals.
              </TeamBio>
            </TeamMember>
          </TeamGrid>
        </TeamSection>

        {/* Contact Section */}
        <ContactSection>
          <SectionTitle>Contact Information</SectionTitle>
          <ContactGrid>
            <ContactCard>
              <ContactIcon>📧</ContactIcon>
              <ContactType>General Inquiries</ContactType>
              <ContactDetail>hello@showingbooker.com</ContactDetail>
              <ContactDescription>Questions about our platform, features, or getting started</ContactDescription>
            </ContactCard>
            <ContactCard>
              <ContactIcon>🛠️</ContactIcon>
              <ContactType>Technical Support</ContactType>
              <ContactDetail>support@showingbooker.com</ContactDetail>
              <ContactDescription>Help with your account, bookings, or technical issues</ContactDescription>
            </ContactCard>
            <ContactCard>
              <ContactIcon>🏢</ContactIcon>
              <ContactType>Business Address</ContactType>
              <ContactDetail>Los Angeles, California</ContactDetail>
              <ContactDescription>Serving real estate professionals throughout California</ContactDescription>
            </ContactCard>
          </ContactGrid>
        </ContactSection>

        {/* FAQ Section */}
        <FAQSection>
          <SectionTitle>Frequently Asked Questions</SectionTitle>
          <FAQList>
            <FAQItem>
              <FAQQuestion 
                onClick={() => setOpenFAQ(openFAQ === 1 ? null : 1)}
                isOpen={openFAQ === 1}
              >
                How does ShowingBooker ensure tenant compliance? {openFAQ === 1 ? '−' : '+'}
              </FAQQuestion>
              {openFAQ === 1 && (
                <FAQAnswer>
                  ShowingBooker automatically handles all tenant notification requirements, including 24-hour advance notice 
                  through multiple channels (email, text, certified mail when required). Our system is designed specifically 
                  for California tenant laws and keeps detailed records for compliance documentation.
                </FAQAnswer>
              )}
            </FAQItem>
            
            <FAQItem>
              <FAQQuestion 
                onClick={() => setOpenFAQ(openFAQ === 2 ? null : 2)}
                isOpen={openFAQ === 2}
              >
                Why is ShowingBooker free for listing agents? {openFAQ === 2 ? '−' : '+'}
              </FAQQuestion>
              {openFAQ === 2 && (
                <FAQAnswer>
                  We believe listing agents should have access to professional showing management tools without cost barriers. 
                  Our revenue comes from the $10 booking fee paid by buyer's agents, which allows us to provide comprehensive 
                  tools to listing agents at no charge.
                </FAQAnswer>
              )}
            </FAQItem>
            
            <FAQItem>
              <FAQQuestion 
                onClick={() => setOpenFAQ(openFAQ === 3 ? null : 3)}
                isOpen={openFAQ === 3}
              >
                How quickly can I set up my first property? {openFAQ === 3 ? '−' : '+'}
              </FAQQuestion>
              {openFAQ === 3 && (
                <FAQAnswer>
                  Most agents have their first property live within 10 minutes of signing up. Our streamlined onboarding 
                  process guides you through property setup, availability scheduling, and compliance configuration quickly 
                  and easily.
                </FAQAnswer>
              )}
            </FAQItem>
            
            <FAQItem>
              <FAQQuestion 
                onClick={() => setOpenFAQ(openFAQ === 4 ? null : 4)}
                isOpen={openFAQ === 4}
              >
                Can I integrate ShowingBooker with my existing calendar? {openFAQ === 4 ? '−' : '+'}
              </FAQQuestion>
              {openFAQ === 4 && (
                <FAQAnswer>
                  Yes! ShowingBooker integrates seamlessly with Google Calendar, Outlook, Apple Calendar, and most other 
                  calendar applications. All bookings automatically sync, and you can export individual showings or 
                  bulk calendar data anytime.
                </FAQAnswer>
              )}
            </FAQItem>
            
            <FAQItem>
              <FAQQuestion 
                onClick={() => setOpenFAQ(openFAQ === 5 ? null : 5)}
                isOpen={openFAQ === 5}
              >
                What makes ShowingBooker different from other scheduling tools? {openFAQ === 5 ? '−' : '+'}
              </FAQQuestion>
              {openFAQ === 5 && (
                <FAQAnswer>
                  ShowingBooker is built specifically for real estate professionals who deal with tenant-occupied properties. 
                  Unlike generic scheduling tools, we handle tenant rights compliance, automated legal notifications, 
                  real estate-specific workflows, and integrate with existing real estate business processes.
                </FAQAnswer>
              )}
            </FAQItem>
          </FAQList>
        </FAQSection>

        {/* Press/Media Section */}
        <PressSection>
          <SectionTitle>Press & Media</SectionTitle>
          <PressContent>
            <PressItem>
              <PressDate>2024</PressDate>
              <PressTitle>ShowingBooker Launches with Focus on Tenant Compliance</PressTitle>
              <PressDescription>
                Los Angeles-based startup introduces the first scheduling platform designed specifically for 
                tenant-occupied property showings, addressing a major gap in real estate technology.
              </PressDescription>
            </PressItem>
            
            <PressItem>
              <PressDate>2024</PressDate>
              <PressTitle>Real Estate Agents Embrace Automated Compliance Technology</PressTitle>
              <PressDescription>
                California agents report significant time savings and reduced legal risk using automated 
                tenant notification systems for property showings.
              </PressDescription>
            </PressItem>
            
            <MediaContact>
              <MediaTitle>Media Inquiries</MediaTitle>
              <MediaInfo>
                For press inquiries, interviews, or media kits, please contact:<br/>
                <strong>Email:</strong> press@showingbooker.com<br/>
                <strong>Response Time:</strong> Within 24 hours
              </MediaInfo>
            </MediaContact>
          </PressContent>
        </PressSection>
      </ContentSection>

      <CTASection>
        <CTAContainer>
          <CTATitle>Ready to Transform Your Showing Process?</CTATitle>
          <CTADescription>
            ShowingBooker is 100% FREE for agents and property owners. 
            Only buyers, renters, and agents pay $25 per property tour booking (for homes or rentals), 
            which includes automated texts, emails, and certified mail notifications.
          </CTADescription>
          <CTAButton onClick={handleGetStarted}>
            {user ? 'Setup a Property for Private Showings' : 'Get Started Free'}
          </CTAButton>
        </CTAContainer>
      </CTASection>
      
      <Footer />
    </Container>
  );
};

export default About;